import { MESApiService, type spParameter } from "../../../services";

export const getStoredProceduresWithParameters = async (
	schemaFilter?: string,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	if (schemaFilter) {
		parameters.push({ name: "SchemaFilter", value: schemaFilter });
	}

	return await apiService.callV2(
		"[SYSTEM].[GetStoredProceduresWithParameters]",
		parameters,
	);
};

export const executeStoredProcedure = async (
	procedureName: string,
	parameters: spParameter[],
) => {
	const apiService = new MESApiService();
	return await apiService.callV2(procedureName, parameters);
};
